import { render, staticRenderFns } from "./dialog-add-contract.vue?vue&type=template&id=25a2d716&scoped=true&"
import script from "./dialog-add-contract.vue?vue&type=script&lang=js&"
export * from "./dialog-add-contract.vue?vue&type=script&lang=js&"
import style0 from "./dialog-add-contract.vue?vue&type=style&index=0&id=25a2d716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2d716",
  null
  
)

export default component.exports